<template>
	<div class="qr-detail" :class="variantClass">
		<img :src="qrSrc" alt="收款码" class="qr-image">
	</div>
</template>

<script>
import qrImage from '../assets/image/qrcode_shoukuan.jpg'

export default {
	name: 'QrDetail',
	props: {
		variant: {
			type: String,
			default: 'page' // 'page' | 'floating' | 'modal'
		},
		lockScroll: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			qrSrc: qrImage
		}
	},
	computed: {
		variantClass() {
			if (this.variant === 'floating') return 'is-floating'
			if (this.variant === 'modal') return 'is-modal'
			return 'is-page'
		}
	},
	mounted() {
		if (this.variant === 'modal' && this.lockScroll) {
			this._oldOverflow = document.body.style.overflow
			document.body.style.overflow = 'hidden'
		}
	},
	beforeDestroy() {
		if (this.variant === 'modal' && this.lockScroll) {
			document.body.style.overflow = this._oldOverflow || ''
		}
	}
}
</script>

<style scoped>
.qr-detail {
	display: flex;
}
.qr-image {
	object-fit: contain;
	box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
	border-radius: 12px;
}

/* 页面独立展示（默认） */
.qr-detail.is-page {
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	background: #ffffff;
}
.qr-detail.is-page .qr-image {
	max-width: 80vw;
	max-height: 80vh;
}

/* 非遮罩浮层：不影响页面交互，无底色 */
.qr-detail.is-floating {
	position: fixed;
	top: 80px;
	right: 24px;
	z-index: 999;
	background: transparent;
	align-items: center;
	justify-content: center;
	pointer-events: auto; /* 仅自身可点，页面其他区域不受影响 */
}
.qr-detail.is-floating .qr-image {
	width: 200px;
	max-width: 42vw;
	height: auto;
}

/* 模态全屏置中，遮罩，禁止滚动在组件内处理 */
.qr-detail.is-modal {
	position: fixed;
	inset: 0;
	z-index: 1000;
	background: rgba(0,0,0,0.55);
	align-items: center;
	justify-content: center;
}
.qr-detail.is-modal .qr-image {
	max-width: 63vw;
	max-height: 63vh;
	width: auto;
	height: auto;
	box-shadow: 0 10px 32px rgba(0,0,0,0.25);
	border-radius: 14px;
}
</style>

